import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { MapCard } from 'Components/_common/CollectionCard/MapCard'
import {
  MAP_STATE_TYPES,
  MAPS_ACCEPTED,
  MAPS_DISCARDED,
  MAPS_UNCHECKED,
  useContestQualificationMapsQuery,
} from 'Queries/Contests'
import React, { useState } from 'react'
import { Else, If, Then } from 'react-if'
import { navigateToQualifyMapModal } from 'Scenes/navigators'
import CustomToggleButtonGroup from 'Theme/CustomToggleButtonGroup'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'

import { ReactComponent as EmptyIcon } from '../../../Assets/img/empty.svg'
import { SkeletonQualificationMapList } from './ContestQualificationSkeletons'

const ContestQualificationList = ({ contestId }) => {
  const [tab, setTab] = useState(MAP_STATE_TYPES[0])
  const queries = {
    [MAPS_UNCHECKED]: useContestQualificationMapsQuery(contestId, MAPS_UNCHECKED),
    [MAPS_ACCEPTED]: useContestQualificationMapsQuery(contestId, MAPS_ACCEPTED),
    [MAPS_DISCARDED]: useContestQualificationMapsQuery(contestId, MAPS_DISCARDED),
  }

  const getMapList = (t) => queries[t]?.data?.data || []
  const getTotalMaps = (t) => Number(queries[t]?.data?.total) || 0
  const getIsLoading = (t) => queries[t]?.isLoading
  const buttonGroupValues = MAP_STATE_TYPES.map((t) => ({ value: t, total: getTotalMaps(t) }))

  const handleModalOpen = (mapId) => navigateToQualifyMapModal(mapId)

  return (
    <Box
      component="section"
      sx={{ marginBottom: '40px' }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '36px',
          marginBottom: '24px',
        }}
      >
        <Typography
          color="text.tertiary"
          sx={(theme) => ({ ...theme.typography.h6 })}
        >
          Qualification List
        </Typography>

        <CustomToggleButtonGroup
          value={tab}
          values={buttonGroupValues}
          onChange={setTab}
        />
      </Box>

      <Box>
        <If condition={getIsLoading(tab)}>
          <Then>
            <SkeletonQualificationMapList />
          </Then>
          <Else>
            <If condition={getTotalMaps(tab) === 0}>
              <Then>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <EmptyIcon />
                </Box>
              </Then>
              <Else>
                <Grid
                  container
                  spacing={2}
                >
                  {getMapList(tab).map((m) => (
                    <Grid
                      item
                      xs={3}
                      key={m.id}
                    >
                      <MapCard
                        map={m}
                        cardAction={() => handleModalOpen(m.id)}
                        cardActionIconClassName={FA_ICONS.CHECK_SLOT}
                        sx={{ height: '192px' }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Else>
            </If>
          </Else>
        </If>
      </Box>
    </Box>
  )
}

export default ContestQualificationList
